<div class="welcome-container">
  <!-- Left Panel -->
  <div class="left-panel">
    <h2 class="headline">CRM platform to Grow your business</h2>
    <p class="subtext">
      Streamline operations, enhance customer experiences, and drive growth with our all-in-one travel industry solutions.
    </p>
    <div class="screenshots">
      <img src="assets/Images/landing-section-img.png" alt="Dashboard" class="main-dashboard" />
      <img src="assets/Images/crm-dashboard.webp" alt="Mobile UI" class="mobile-ui" />
    </div>
  </div>

  <!-- Middle Panel (Form) -->
  <div class="middle-panel">
    <div class="org-container" *ngIf="orgName">
      <h2 class="org-name">{{orgName}}</h2>
      <p class="welcome-user">Hey {{userName}}! You're just one step away from logging in. Let's reset that password and get you back in action!</p>
    </div>
    <form [formGroup]="passwordChangeForm" (ngSubmit)="onSubmit()" class="password-box" novalidate>
      <h1>Create Password</h1>

      <!-- New Password -->
      <div class="input-wrapper mb-0">
        <ion-input type="password" formControlName="newPassword" placeholder="New Password *">
          <ion-input-password-toggle slot="end"></ion-input-password-toggle>
        </ion-input>
      </div>
      <div class="mb-2">
        <div class="password-validation" [ngClass]="{'valid': hasUpperCase()}">
          <ion-icon [name]="hasUpperCase() ? 'checkmark-outline' : 'close-outline'"></ion-icon>
          <p class="msg">Must contain one uppercase</p>
        </div>
        <div class="password-validation" [ngClass]="{'valid': hasLowerCase()}">
          <ion-icon [name]="hasLowerCase() ? 'checkmark-outline' : 'close-outline'"></ion-icon>
          <p class="msg">Must contain one lowercase</p>
        </div>
        <div class="password-validation" [ngClass]="{'valid': hasSpecialChar()}">
          <ion-icon [name]="hasSpecialChar() ? 'checkmark-outline' : 'close-outline'"></ion-icon>
          <p class="msg">Must contain one special character</p>
        </div>
        <div class="password-validation" [ngClass]="{'valid': hasNumber()}">
          <ion-icon [name]="hasNumber() ? 'checkmark-outline' : 'close-outline'"></ion-icon>
          <p class="msg">Must contain one number</p>
        </div>
        <div class="password-validation"
             [ngClass]="{'valid': hasMinLength() && !isEmpty()}">
          <ion-icon [name]="hasMinLength() && !isEmpty() ? 'checkmark-outline' : 'close-outline'"></ion-icon>
          <p class="msg">8 characters minimum</p>
        </div>
      </div>

      <!-- Confirm Password -->
      <div class="input-wrapper mb-0">
        <ion-input type="password" formControlName="confirmNewPassword" placeholder="Confirm Password *">
          <ion-input-password-toggle slot="end"></ion-input-password-toggle>
        </ion-input>
      </div>
      <div *ngIf="passwordChangeForm.get('confirmNewPassword')?.touched && passwordChangeForm.get('confirmNewPassword')?.invalid" class="error-message">
        <p *ngIf="passwordChangeForm.get('confirmNewPassword')?.errors?.['required']">Confirm Password is required.</p>
        <p *ngIf="passwordChangeForm.get('confirmNewPassword')?.errors?.['passwordMismatch']">Passwords do not match.</p>
      </div>

      <!-- Expired Message -->
      <div class="text-danger" *ngIf="expired">
        The user's session has expired. Please log in again.
      </div>

      <!-- Backend Error -->
      <div class="text-danger" *ngIf="errorMessage">
        <p class="text mb-0">{{ errorMessage }}</p>
      </div>

      <!-- Submit Button -->
      <button type="submit" class="create-btn mt-2" [disabled]="passwordChangeForm.invalid">Create Account</button>
    </form>
  </div>

  <!-- Right Panel -->
  <div class="assistance d-flex flex-column justify-content-center px-4">
    <h5 class="fw-bold text-primary mb-1">Need Assistance</h5>
    <p class="mb-3 text-muted">Contact us for more details</p>
    <p class="mb-3">
      <ion-icon name="call-outline" class="me-2"></ion-icon>
      +91 928 111 7175
    </p>
    <p>
      <ion-icon name="mail-outline" class="me-2"></ion-icon>
      {{"contact@tripmeld.com"}}
    </p>
  </div>
  <app-spinner *ngIf="showSpinner"></app-spinner>
</div>
